// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dKEs","importantInfo":"styles_importantInfo__3t02k"};